import React from 'react'
import { CirclePlay , Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


export default function Card_2({ video , channel }) {

    const navigate = useNavigate();

    console.log(channel)

    function convertToMinutes(numb) {
        const totalSeconds = Math.floor(numb * 0.0166667 * 60); // convert to seconds
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // Add leading zeros
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    }


    return (
        <div className='carddiv' onClick={()=> navigate("/video", { state: { video, channel : channel.Content } }  )} >
            
    
            <div style={{position:'relative' , width:'100%' , height:'100%'}} >
                <img src={video.Thumbnail} className="card-img-top" alt="..."  width={'100%'}  height={'100%'}/>
                <span className='time' style={{ position: 'absolute', bottom: '5px' , right:'5px'}}>{convertToMinutes(video.Duration)}</span>
            </div>



            <div className='card_3_info' >
                <CirclePlay size={40} strokeWidth={'1px'}/>
                <h5 className='card-title'>{video.Title}</h5>
                <p>{channel.Name}</p>
            </div>
        </div>
    )
}
